module.exports = __webpack_public_path__ + "static/mnews08.png";